import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import { useEffect, useRef } from "react";

export default function useCollabSavedMeasurements(projectId, onRemoteUpdate) {
  const ydocRef = useRef(null);
  const providerRef = useRef(null);
  const yArrRef = useRef(null);

  useEffect(() => {
    if (!projectId) return;

    const ydoc = new Y.Doc();

    // EXACTLY the same base URL you use for measurements
    const raw = process.env.REACT_APP_SOCKET_URL || "ws://localhost:1234";
    const socketUrl = raw.replace(/['"\s]+/g, "").replace(/\/+$/g, "");
    const room = String(projectId).trim();

    const provider = new WebsocketProvider(socketUrl, room, ydoc);
    const yArr = ydoc.getArray("savedMeasurements");

    const observer = () => onRemoteUpdate?.(yArr.toJSON());
    yArr.observe(observer);
    observer(); // initial hydrate

    ydocRef.current = ydoc;
    providerRef.current = provider;
    yArrRef.current = yArr;

    return () => {
      try {
        yArr.unobserve(observer);
      } catch {}
      try {
        provider.destroy();
      } catch {}
      try {
        ydoc.destroy();
      } catch {}
    };
  }, [projectId]);

  // atomic replace to avoid empty flashes
  const syncSavedMeasurements = (updated) => {
    const yArr = yArrRef.current;
    const ydoc = ydocRef.current;
    if (!yArr || !ydoc) return;

    const next = Array.isArray(updated) ? updated : [];
    ydoc.transact(() => {
      yArr.delete(0, yArr.length);
      if (next.length) yArr.insert(0, next);
    });
  };

  return { syncSavedMeasurements };
}
